module.exports = __webpack_public_path__ + "static/media/alberta.112a540d.png";